module.exports = __webpack_public_path__ + "img/no-info.2e14912.png";